import React, { useState, useEffect } from 'react';
import { Button, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, FormGroup } from 'reactstrap';

const ButtonClose = ({ handleClick }) => (
    <Button color='secondary' onClick={handleClick}>
        Fechar
    </Button>
);

const ButtonSave = ({ handleClick, textoFoto, radioSelecionado, oficial }) => (
    <Button type='submit' size='md' color='primary' onClick={(e) => handleClick(textoFoto, radioSelecionado, oficial)}>
        Salvar
    </Button>
);

const InputRadio = ({ handleChange, value, name }) => (
    <FormGroup check inline>
        <Input
            defaultChecked={value === 'N'}
            className='form-check-input'
            type='radio'
            id={name}
            name='inline-radios'
            value={value}
            onChange={handleChange}
        />
        <Label className='form-check-label' check htmlFor={name}>
            {name}
        </Label>
    </FormGroup>
);

const InputOficialRadio = ({ handleChange, value, name }) => (
    <FormGroup check inline>
        <Input className='form-check-input' type='checkbox' id={name} name='inline-radios' value={value} onChange={handleChange} />
        <Label className='form-check-label' check htmlFor={name}>
            {name}
        </Label>
    </FormGroup>
);

const InputText = ({ handleChange, value }) => (
    <FormGroup>
        <Label htmlFor='textoFoto'>Nome da foto</Label>
        <Input
            onChange={handleChange}
            type='text'
            id='textoFoto'
            placeholder=''
            value={value}
            className='col-sm-12 form-control-sm'
            autoComplete='off'
        ></Input>
    </FormGroup>
);

const ModalSalvarFoto = ({ toggle, handleSave }) => {
    const [textoFoto, setTextoFoto] = useState('');
    const [radioSelecionado, setRadioSelecionado] = useState('S');
    const [oficial, setOficial] = useState(false);

    const handleInputChange = (event) => setTextoFoto(event.target.value);
    const handleOnChange = (event) => setRadioSelecionado(event.target.value);

    useEffect(() => {
        return () => {
            setTextoFoto('');
            setRadioSelecionado('');
        };
    }, []);

    return (
        <Modal className='modal-dialog' isOpen={true} style={{ maxWidth: '750px' }}>
            <ModalHeader>Salvar foto</ModalHeader>
            <ModalBody>
                <InputRadio handleChange={handleOnChange} value={'S'} name={'Simulação'} />
                <InputRadio handleChange={handleOnChange} value={'F'} name={'Fechamento'} />
                <InputOficialRadio handleChange={(e) => setOficial(!oficial)} value={oficial} name={'Oficial'} />
                <InputText handleChange={handleInputChange} value={textoFoto} />
            </ModalBody>
            <ModalFooter>
                <ButtonSave handleClick={handleSave} textoFoto={textoFoto} radioSelecionado={radioSelecionado} oficial={oficial} />
                <ButtonClose handleClick={toggle} />
            </ModalFooter>
        </Modal>
    );
};

export default ModalSalvarFoto;
